import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import theme from './theme';

import './sass/main.scss';
import store from './store';
import AppView from './views/AppView.jsx';
import registerServiceWorker from './registerServiceWorker';

store.dispatch({ type: 'RENDERING_APP' });



ReactDOM.render(
	<Provider store={store}>
		<MuiThemeProvider theme={theme}>
			<AppView />
		</MuiThemeProvider>
	</Provider>
, document.getElementById('root'), function() {
	store.dispatch({ type: 'RENDERED_APP' });
});

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js